import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/index'
import store from '@/store/index'
// normalize
import 'normalize.css/normalize.css'
// 初始化和通用css
import '@/style/common.css';

// element
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)

// 本应用通用css
import '@/style/app.less';
// 路由钩子已整合到router/index.js中

Vue.config.productionTip = false



new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
